import { render, staticRenderFns } from "./createCaptcha.vue?vue&type=template&id=617686a5&"
import script from "./createCaptcha.vue?vue&type=script&lang=js&"
export * from "./createCaptcha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports